import { nanoid } from 'nanoid';
import React, { FC, useMemo } from 'react';
import { Container, Row, Cell, CellContainer } from './styles';
import { Props } from './types';

const Placeholder: FC<Props> = ({
  columns,
  numberOfRows = 5,
  animated = false,
  ...props
}) => {
  const rowIds = useMemo(
    () =>
      Array(numberOfRows)
        .fill(0)
        .map(() => nanoid(4)),
    [numberOfRows],
  );
  return (
    <Container {...props}>
      {rowIds.map((rowId) => (
        <Row key={rowId}>
          {columns.map((column) => (
            <CellContainer key={`${rowId}-${column.accessor}`}>
              <Cell $width={column.width || 150} $animated={animated} />
            </CellContainer>
          ))}
        </Row>
      ))}
    </Container>
  );
};

export default Placeholder;
